import { createContext, MouseEvent, PropsWithChildren, useContext } from 'react'

export interface CtaAnalyticsParams {
  text: string
  style: string
  href: string
  component: string
}

type LogClickFunction = (params: CtaAnalyticsParams) => void

interface CtaAnalyticsProps {
  logClick: LogClickFunction
}

const CtaAnalyticsContext = createContext<CtaAnalyticsProps>({
  logClick(_) {
    // Do nothing
  },
})

export const CtaAnalyticsProvider = ({ logClick, children }: PropsWithChildren<CtaAnalyticsProps>) => (
  <CtaAnalyticsContext.Provider value={{ logClick }}>{children}</CtaAnalyticsContext.Provider>
)

export const useCtaAnalytics = () => useContext(CtaAnalyticsContext)

export const makeCtaAnalyticsClickHandler =
  <T extends HTMLButtonElement | HTMLAnchorElement>(
    logClick: LogClickFunction,
    params: CtaAnalyticsParams,
    onClick?: (e: MouseEvent<T>) => void
  ) =>
  (e: MouseEvent<T>) => {
    logClick(params)
    onClick?.(e)
  }
